<template>
  <div class="project-target">
    <div class="header-section">
      <h2>设置留言目标数</h2>
      <div class="header-controls">
        <el-select v-model="quickDate" placeholder="快速选择日期" style="width: 120px;">
          <el-option label="昨天" value="yesterday" />
          <el-option label="前天" value="dayBeforeYesterday" />
          <el-option label="大前天" value="threeDaysAgo" />
        </el-select>
        <el-button type="primary" @click="onQuickDateChange">同步目标数</el-button>
      </div>
    </div>
    <el-table :data="projectList" style="width: 100%" border>
      <el-table-column prop="projectName" label="项目名称" align="center" />
      <el-table-column label="目标数" align="center">
        <template slot-scope="scope">
          <el-input v-model="scope.row.messageCount" placeholder="请输入目标数" type="number" min="0" style="width: 100px;" />
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="120">
        <template slot-scope="scope">
          <el-button
            type="text"
            icon="el-icon-arrow-up"
            @click="moveUp(scope.$index)"
            :disabled="scope.$index === 0"
            size="medium"
          />
          <el-button
            type="text"
            icon="el-icon-arrow-down"
            @click="moveDown(scope.$index)"
            :disabled="scope.$index === projectList.length - 1"
            size="medium"
          />
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top: 24px; text-align: right; display: flex; justify-content: flex-end; align-items: center; gap: 16px;">
      <el-date-picker
        v-model="targetDate"
        type="date"
        placeholder="选择日期"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
        style="width: 130px;"
        @change="onDateChange"
      />
      <el-button type="primary" @click="saveTargets">保存</el-button>
      <el-button @click="cancel">取消</el-button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'ProjectTarget',
  data() {
    return {
      projectList: [],
      targetDate: '',
      quickDate: 'yesterday'
    }
  },
  mounted() {
    this.setToday();
    this.loadTargets();
  },
  methods: {
    setToday() {
      const today = new Date();
      const y = today.getFullYear();
      const m = String(today.getMonth() + 1).padStart(2, '0');
      const d = String(today.getDate()).padStart(2, '0');
      this.targetDate = `${y}-${m}-${d}`;
    },
    onDateChange() {
      this.loadTargets();
    },
    onQuickDateChange() {
      if (!this.quickDate) return;

      const today = new Date();
      let targetDate = new Date();

      switch (this.quickDate) {
        case 'yesterday':
          targetDate.setDate(today.getDate() - 1);
          break;
        case 'dayBeforeYesterday':
          targetDate.setDate(today.getDate() - 2);
          break;
        case 'threeDaysAgo':
          targetDate.setDate(today.getDate() - 3);
          break;
      }

      const y = targetDate.getFullYear();
      const m = String(targetDate.getMonth() + 1).padStart(2, '0');
      const d = String(targetDate.getDate()).padStart(2, '0');
      const targetNumber = `${y}-${m}-${d}`;

      this.loadTargets(targetNumber);
    },
    async loadTargets(targetNumber) {
      if (!this.targetDate) return;
      var targetNumber1;
      if(targetNumber) {
        targetNumber1 = targetNumber;
      }
      else {
        targetNumber1 = this.targetDate;
      }
      
      try {
        // 获取用户信息
        const userInfoRes = await axios.get('/api/user/info');
        const userInfo = userInfoRes.data;
        const authority = userInfo.authority;
        const employeeId = userInfo.employeeId;
        
        let url;
        if (authority == 1) {
          url = `/api/messageCount/getAllByTimeWithOrder?time=${targetNumber1}`;
        } else {
          url = `/api/messageCount/getAllByTimeWithOrderAndEmployee?employeeId=${employeeId}&time=${targetNumber1}`;
        }
        
        const response = await axios.get(url);
        if (response.data.success) {
          // 根据order字段进行排序，从小到大
          this.projectList = response.data.data
            .sort((a, b) => a.order - b.order)
            .map(item => ({
              ...item,
              messageCount: typeof item.messageCount === 'number' ? item.messageCount : 0
            }));
        } else {
          this.$message.error('获取目标数失败: ' + (response.data.message || '未知错误'));
        }
      } catch (error) {
        this.$message.error('获取目标数失败: ' + error);
      }
    },
    moveUp(index) {
      if (index > 0) {
        // 创建新数组来触发响应式更新
        const newList = [...this.projectList];
        const temp = newList[index];
        newList[index] = newList[index - 1];
        newList[index - 1] = temp;
        this.projectList = newList;
      }
    },
    moveDown(index) {
      if (index < this.projectList.length - 1) {
        // 创建新数组来触发响应式更新
        const newList = [...this.projectList];
        const temp = newList[index];
        newList[index] = newList[index + 1];
        newList[index + 1] = temp;
        this.projectList = newList;
      }
    },
    saveTargets() {
      if (!this.targetDate) {
        this.$message.warning('请选择日期');
        return;
      }
      const targets = this.projectList.map((item, index) => ({
        projectId: item.projectId,
        messageCount: Number(item.messageCount),
        time: this.targetDate,
        order: index + 1
      }));
      axios.post('/api/messageCount/addBatch', targets)
        .then(response => {
          if (response.data.success) {
            this.$message.success('保存成功');
            setTimeout(() => {
              this.$router.push({ name: 'ProjectStats' });
            }, 1000);
          } else {
            this.$message.error('保存失败: ' + (response.data.message || '未知错误'));
          }
        })
        .catch(error => {
          this.$message.error('保存失败: ' + error);
        });
    },
    cancel() {
      this.$router.push({ name: 'ProjectStats' });
    },
    /*tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return 'even-row';
      }
      return '';
    }*/
  }
}
</script>

<style scoped>
.project-target {
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  padding: 32px;
  max-width: 800px;
  margin: 12px auto;
}

.header-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.header-controls {
  display: flex;
  align-items: center;
  gap: 12px;
}

.even-row {
  background-color: #f5f7fa;
}

/deep/ .el-table .even-row {
  background-color:rgb(160, 202, 244) !important;
}

/* 移动端样式优化 */
@media (max-width: 768px) {
  .project-target {
    padding: 16px;
    margin: 8px;
    max-width: none;
  }
  
  /* 头部布局优化 */
  .header-section {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
    margin-bottom: 20px;
  }
  
  .header-section h2 {
    text-align: center;
    margin: 0;
    font-size: 18px;
  }
  
  .header-controls {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
  
  .header-controls .el-select {
    width: 100% !important;
  }
  
  .header-controls .el-button {
    width: 100%;
  }
  
  /* 表格优化 */
  .el-table {
    overflow-x: auto;
    white-space: nowrap;
  }
  
  .el-table .el-table__body-wrapper {
    min-width: 600px;
  }
  
  .el-table th,
  .el-table td {
    white-space: nowrap;
  }
  
  /* 底部操作区域优化 */
  .project-target > div:last-child {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    margin-top: 20px;
  }
  
  .project-target > div:last-child .el-date-picker {
    width: 100% !important;
  }
  
  .project-target > div:last-child .el-button {
    width: 100%;
  }
  
  /* 表格内输入框优化 */
  .el-table .el-input {
    width: 80px !important;
  }
  
  /* 操作按钮优化 */
  .el-table .el-button {
    padding: 4px 8px;
    font-size: 12px;
  }
}

</style>